import styled from 'styled-components';
import Checkbox from 'modules/Common/Components/Checkbox';
import Announce from '../../../../assets/img/icons/announcement.svg';
import Dots from '../../../../assets/img/3VerticalDots.svg';
import { Popover, message, Typography } from 'antd';
import { ReactComponent as CopyText } from '../../../../assets/img/copy.svg';
import EditIcon from 'assets/svgs/EditIcon';
import DeleteIcon from 'assets/svgs/DeleteIcon';
import { IFormData } from '../interfaces';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
const { Text } = Typography;

const commonCSS = {
  color: '#7E7E7E',
  fontFamily: 'Roboto',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '24px',
  cursor: 'pointer',
  display: 'flex',
  gap: '9px',
};
const commonFlexCSS = {
  display: 'flex',
  alignItems: 'center',
  // flex: 1,
};
const Wrapper = styled.div`
  margin: 0 2px;
  :hover {
    cursor: pointer;
  }
  .unselect-card {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: #fff;
    margin-top: 8px;
    box-shadow: 0px 0px 9px -1.40625px rgba(0, 0, 0, 0.08);
    margin-bottom: 8px;
  }
  .selected-card {
    outline: 2px solid #1ec252;
    background: #ecfaf1;
  }
  .checkbox-wrapper {
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    label span {
      padding: 0 !important;
      width: 19px !important;
      height: 19px !important;
    }
  }
  .clone-icon {
    width: 20px !important;
  }
  @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
    .name {
      font-size: 13px !important;
    }
    .campaign {
      font-size: 13px !important;
    }
    .url {
      font-size: 13px !important;
      .custom-tooltip-text {
        width: 113px !important;
      }
    }
    .submission {
      font-size: 13px !important;
    }
    .updated {
      font-size: 13px !important;
    }
  }
`;
const WrapperContent = styled.div`
  display: flex;
  /* flex: 1; */
  align-items: center;
  .name {
    ${commonFlexCSS};
    flex: 2;
    @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
      flex: 7.8% !important;
    }
    .custom-tooltip-text {
      width: 220px !important;
      color: #5e7079;
      font-family: 'Roboto Slab';
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      @media all and (max-width: 1439px) {
        width: 125px !important;
      }
    }
    .form-ellipse-title {
      color: #000;
      font-family: 'Roboto Slab';
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.75px;
      @media all and (max-width: 1439px) {
        font-size: 18px !important;
      }
      @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
        font-size: 16px !important;
      }
    }
  }
  .campaign {
    display: flex;
    align-items: center;
    padding-top: 4px;
    .form-ellipse-campaign {
      color: #5e7079;
      font-family: 'Roboto';
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      @media all and (max-width: 1439px) {
        font-size: 12px !important;
      }
    }
    img {
      padding-right: 6px;
    }
  }
  .url {
    ${commonFlexCSS};
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    .form-ellipse-url {
      color: #868685;
      font-family: 'Roboto';
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */
      letter-spacing: -0.4px;
      @media all and (max-width: 1439px) {
        font-size: 12px !important;
      }
    }
    .url-copy-text {
      overflow: hidden;
      overflow-wrap: anywhere;
      text-overflow: ellipsis;
      width: 200px;
      display: flex;
      align-items: center;
      margin: 0;
    }
  }
  .submission {
    ${commonFlexCSS};
    flex: 1;
    span {
      color: #1ec252;
      text-align: center;
      font-family: 'Roboto';
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 47px;
      text-decoration: underline;
      cursor: pointer;
      padding-left: 50px;
      @media all and (max-width: 1280px) {
        padding-left: 40px !important;
      }
    }
  }
  .updated {
    ${commonFlexCSS};
    flex: 1;
    color: #868685;
    font-family: 'Roboto';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 47px;
    @media all and (max-width: 1439px) {
      font-size: 12px !important;
    }
  }
  .form-menu {
    width: 30px;
    margin: 0;
    @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
      width: 28px;
      margin: 0;
      text-align: end;
      padding-right: 10px;
    }
    .ant-popover-arrow {
      border-radius: 2px;
    }
    .ant-popover-placement-leftTop > .ant-popover-content > .ant-popover-arrow {
      box-shadow: 5px -5px 7px rgba(0, 0, 0, 0.05);
    }
    .ant-popover-inner-content {
      padding: 16px 18px !important;
    }
    .ant-popover-inner {
      width: 147px !important;
    }
    img {
      width: 4px;
      cursor: pointer;
    }
  }
  #form-edit-icon {
    display: flex !important;
    align-items: center !important;
  }
  #form-delete-icon {
    display: flex !important;
    align-items: center !important;
  }
`;

interface IFormListCardProps {
  form: IFormData;
  handleOnClickCheckbox: (checked: boolean, id: number) => void;
  selectedFormIds: number[];
  selectAll: boolean;
  excludedFormIds: number[];
  setIsOpenDeletePopUp: (val: boolean) => void;
  setTempObj: (obj: { id: number; name: string }) => void;
}

const FormDetailListingCard: React.FC<IFormListCardProps> = (props: IFormListCardProps) => {
  // Props
  const { form, handleOnClickCheckbox, selectedFormIds, selectAll, excludedFormIds, setIsOpenDeletePopUp, setTempObj } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [ellipsis, setEllipsis] = useState(true);

  // Local Variables
  const history = useHistory();

  const redirectToCampaign = (e: any) => {
    e.stopPropagation();
    history.push(`/campaigns/content?campaign_id=${form.campaignId}&from=forms`);
  };

  const handleOpenChange = () => {
    setOpenDropdown(!openDropdown);
  };

  // Functions
  const content = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 13 }}>
      <span
        id="form-edit-icon"
        style={commonCSS}
        onClick={(e) => {
          e.stopPropagation();
          history.push(`/settings/forms/create_form?form_id=${form.id}&from=forms`);
        }}
      >
        <EditIcon width="17px" height="17px" />
        <span style={{ marginTop: '2px' }}>Edit</span>
      </span>
      {/* <span id="form-clone-icon" style={commonCSS}>
        <span style={{ paddingRight: '10px' }}>
          <ClonePlusIcon />
        </span>
        Clone
      </span> */}
      <span
        id="form-delete-icon"
        style={commonCSS}
        onClick={(e) => {
          e.stopPropagation();
          setTempObj({ id: form.id, name: form.name });
          setIsOpenDeletePopUp(true);
          setOpenDropdown(false);
        }}
      >
        <DeleteIcon />
        <span style={{ marginTop: '2px' }}>Delete</span>
      </span>
    </div>
  );

  return (
    <Wrapper
      onClick={() => {
        history.push(`/settings/forms?form_id=${form.id}`);
      }}
      className="form-listing-card-wrapper"
      // id={`${
      //   (selectAll && !excludedFormIds.includes(form.id)) || (!selectAll && selectedFormIds.includes(form.id)) || selectAll
      //     ? 'selected-form-listing-wrapper'
      //     : ''
      // }`}
    >
      <WrapperContent
        className={`unselect-card ${
          (selectAll && !excludedFormIds.includes(form.id)) || (!selectAll && selectedFormIds.includes(form.id)) ? 'selected-card' : 'unselect-card'
        }`}
      >
        <div className="name">
          <span style={{ paddingLeft: '24px', display: 'flex', alignItems: 'center' }}>
            <Checkbox
              className="form-listing-checkbox"
              checked={(selectAll && !excludedFormIds.includes(form.id)) || (!selectAll && selectedFormIds.includes(form.id))}
              onClick={(e: any) => handleOnClickCheckbox(e.target.checked, form.id)}
            />
            <span className="name" style={{ display: 'flex', flexFlow: 'column', alignItems: 'flex-start', paddingLeft: '24px' }}>
              <Text
                className="form-ellipse-title"
                // style={ellipsis ? { paddingRight: '0' } : undefined}
                ellipsis={ellipsis ? { tooltip: `${form.name}` } : false}
              >
                {form.name}
              </Text>
              {form.campaignName?.length > 0 ? (
                <span className="campaign">
                  <>
                    <img src={Announce} alt="img" />
                    <Text
                      className="form-ellipse-campaign"
                      style={ellipsis ? { paddingRight: '0' } : undefined}
                      ellipsis={ellipsis ? { tooltip: `${form.campaignName}` } : false}
                      onClick={redirectToCampaign}
                    >
                      {form.campaignName}
                    </Text>
                  </>
                </span>
              ) : null}
            </span>
          </span>
        </div>
        <div
          className="url"
          onClick={(e) => {
            e.stopPropagation();
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Text className="form-ellipse-url" ellipsis={ellipsis ? { tooltip: `${form.formUrl}` } : false}>
            {form.formUrl}
          </Text>
          {isHovered && (
            <CopyToClipboard text={form.formUrl}>
              <span>
                <CopyText onClick={() => message.success({ content: 'URL Copied', key: 1 })} style={{ cursor: 'pointer' }} width={22} height={20} />
              </span>
            </CopyToClipboard>
          )}
        </div>
        <div className="submission">
          <span>{form.submissions}</span>
        </div>
        <div className="updated">
          <span style={{ paddingLeft: '4px' }}>{form.lastUpdated}</span>
        </div>
        <div className="form-menu">
          <span>
            <Popover
              placement="leftTop"
              content={content}
              trigger="click"
              open={openDropdown}
              getPopupContainer={() => document.querySelectorAll('.form-menu')[0] as HTMLElement}
              onOpenChange={handleOpenChange}
            >
              <img
                onClick={(e) => {
                  e.stopPropagation();
                }}
                src={Dots}
                alt="#"
              />
            </Popover>
          </span>
        </div>
      </WrapperContent>
    </Wrapper>
  );
};

export default FormDetailListingCard;
